module.exports = __webpack_public_path__ + "static/media/KARAN ACOUSTICS MASTER COLLECTION POWER B STEREO.e4736f5e.png";